import { CommonModule } from '@angular/common';
import { Component, ContentChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SidebarBaseComponent } from './sidebar-base/sidebar-base.component';
import { MainBaseComponent } from './main-base/main-base.component';

@Component({
  selector: 'app-master-detail-layout',
  standalone: true,
  imports: [ 
    CommonModule, MatIconModule, MatButtonModule,
    SidebarBaseComponent, MainBaseComponent
  ],
  templateUrl: './master-detail-layout.component.html',
  styleUrl: './master-detail-layout.component.scss'
})
export class MasterDetailLayoutComponent {
  @Input() isMobile: boolean = false;
  @Input() showDetail: boolean = false;
  @Output() backToSidebar = new EventEmitter<void>();

  @ContentChild('sidebarTitle') hasSidebarTitle?: ElementRef;
  @ContentChild('sidebarActions') hasSidebarActions?: ElementRef;
  @ContentChild('sidebarContent') hasSidebarContentRef?: ElementRef;

  @ContentChild('headerTitle') headerTitleRef?: ElementRef;
  @ContentChild('content') contentRef?: ElementRef;
  @ContentChild('mainContent') hasMainContentRef?: ElementRef;

  get showSidebarHeader(): boolean {
    return !!this.hasSidebarTitle || !!this.hasSidebarActions;
  }

  get hasSidebarContent(): boolean {
    return !!this.hasSidebarContentRef;
  }

  get hasMainContent(): boolean {
    return !!this.hasMainContentRef;
  }

}
